<template>
    <div class="user-info">
        <IconUser v-if="!hideIcon" class="icon icon-user" />
        <span>{{ fio }}</span>
        <TooltipOld bind-to=".user-info" class="inform tooltip-user" trigger-on="hover">
            <div v-show="post" class="post">{{ post }}</div>
            <a v-show="email" :href="'mailto:' + email" class="email accent">{{ email }}</a>
            <div v-show="value.phone" class="phone">{{ value.phone | prettyPhone }}</div>
        </TooltipOld>
    </div>
</template>

<script>
import IconUser from '@/common/page_comp/UserInfo/icons/user.svg';


export default {
    name: 'UserInfo',
    components: { IconUser },
    props: {
        value: {
            type: Object,
            required: true,
        },
        hideIcon: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        fio() {
            return this.value.fio ?? '';
        },
        post() {
            return this.value.post ?? '';
        },
        email() {
            return this.value.email ?? '';
        },
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
.user-info {
    display: inline-block;

    .icon-user {
        margin-right: 2px;
    }
}

.tooltip-user {
    padding: 12px 20px !important;
}
</style>
